"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ethUtil = require('ethereumjs-util');

var Engine = require('./engine').zeroc;

var util = require('../util');

var error = require('../constant/error');

var LiteWallet =
/**
 * @constructor
 * @param {*} net - Network id
 * @param {*} accOpts - accOpts = {
 *   address: ...
 *   privateKey: ...
 * }
 */
function LiteWallet(net) {
  var _this = this;

  _classCallCheck(this, LiteWallet);

  _defineProperty(this, "opts", function () {
    return {
      dataHandler: function dataHandler() {
        /* Turn off default logs */
      },
      errorHandler: function errorHandler() {
        /* Turn off dÎefault logs */
      },
      getAccounts: function getAccounts(callback) {
        var accounts = _this.getAddress();

        return callback(null, accounts);
      },
      approveTransaction: function approveTransaction(txParams, callback) {
        return callback(null, true);
      },
      signTransaction: function signTransaction(txParams, callback) {
        var priv = _this.getPrivateKey();

        if (!priv) return callback(error.CANNOT_UNLOCK_ACCOUNT, null);
        txParams.chainId = _this.network;
        var signedTx = util.signRawTx(txParams, priv);
        return callback(null, signedTx);
      },
      killSession: function killSession() {// Interface consistency
      }
    };
  });

  _defineProperty(this, "init", function (accOpts, callback) {
    accOpts = accOpts || {};
    var engine = new Engine(_this.network, _this.opts());
    return _this.setAccount(accOpts, function (er, re) {
      if (er || !re) return callback(error.CANNOT_SET_ACCOUNT, null);
      return callback(null, engine.web3);
    });
  });

  _defineProperty(this, "setAccount", function (accOpts, callback) {
    var address = accOpts.address,
        privateKey = accOpts.privateKey;
    if (!address || !privateKey) return callback(error.CANNOT_GET_ACCOUNT, null);
    address = address.toLowerCase();
    privateKey = privateKey.toLowerCase();
    if (!_this.validatePrivateKey(address, privateKey)) return callback(error.CANNOT_GET_ACCOUNT, null);
    _this.acc = {
      address: address,
      privateKey: privateKey
    };
    return callback(null, _this.acc);
  });

  _defineProperty(this, "validatePrivateKey", function (addr, priv) {
    try {
      if (!addr || !priv) return false;
      priv = new Buffer(priv, 'hex');
      var valid = ethUtil.isValidPrivate(priv);

      var _addr = '0x' + ethUtil.privateToAddress(priv).toString('hex');

      valid = valid && _addr === addr;
      return valid;
    } catch (er) {
      if (er) return false;
    }
  });

  _defineProperty(this, "getAddress", function () {
    if (!_this.acc || _typeof(_this.acc) !== 'object') return [];
    return [_this.acc.address];
  });

  _defineProperty(this, "getPrivateKey", function () {
    if (!_this.acc || _typeof(_this.acc) !== 'object') return null;
    return _this.acc.privateKey;
  });

  this.network = util.getNetworkId(net, 'number');
  this.acc = null;
}
/**
 * @func opts
 * Define optional functions for engine
 */
;

module.exports = LiteWallet;